<pace-core-side-menu></pace-core-side-menu>
<pace-core-navigation-link></pace-core-navigation-link>
<pace-core-whats-new></pace-core-whats-new>
<div class="gid">
    <fa-icon [icon]="faUser"></fa-icon><span> {{ gid }}</span>
</div>
<pace-core-sync-indicator *ngIf="displaySync"></pace-core-sync-indicator>
